import { Content, Header } from '../../../libs/gs-component-right-rail';
import Icon from '@xo-union/tk-component-icons';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useHistory } from 'react-router-dom';

import styles from '../PhotoGallery/edit.scss';

interface Props {
  addUploads(fileRefs: File[]): Promise<void>;
  onBackHandler?: () => void;
}

const Dropzone: React.FC<Props> = ({ addUploads, onBackHandler }) => {
  const history = useHistory();
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: addUploads,
    accept: 'image/*',
  });
  const closeRightRail = () => {
    history.push('/gs/dashboard');
  };
  return (
    <>
      <Header
        leftButtonText={onBackHandler ? 'Back' : undefined}
        leftButtonOnClick={onBackHandler ? onBackHandler : undefined}
        onClose={onBackHandler ? undefined : closeRightRail}
        as="h1"
      >
        Add a Photo Memory
      </Header>
      <Content>
        <div {...getRootProps()} className={styles.dropzone}>
          <input {...getInputProps()} data-testid="photo-timeline-upload" />
          <Icon className={styles.dropzoneIcon} name="download" size="lg" />
          <span>
            Click to Select Photos <br />
            or Drag Them Here
          </span>
        </div>
      </Content>
    </>
  );
};

export default Dropzone;
